import { render, staticRenderFns } from "./Endorsements.vue?vue&type=template&id=b77eea58"
import script from "./Endorsements.vue?vue&type=script&lang=js"
export * from "./Endorsements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports